import { Component, Input, OnInit, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-erp-modules-smartart',
  template: `
    <div class="smartart-container">
      <div class="smartart-wrapper">
        <!-- Root Node - Center -->
        <div class="root-node">
          <div class="node-content">
            <i data-lucide="layers" class="root-icon"></i>
            <span>Smart ERP Modules</span>
          </div>
        </div>
        
        <!-- Modules arranged in circle -->
        <div class="modules-circle">
          <div 
            class="module-node" 
            *ngFor="let module of modules; let i = index"
            [style.--angle]="(i * 360 / modules.length - 90) + 'deg'">
            <div class="connection-line"></div>
            <div class="module-card">
              <div class="module-icon">
                <i [attr.data-lucide]="module.icon" class="module-icon-svg"></i>
              </div>
              <div class="module-name">{{ module.name }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .smartart-container {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 3rem 2rem;
      background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
      border-radius: 20px;
      box-shadow: 0 8px 24px rgba(0,0,0,0.08);
      border: 1px solid rgba(28,62,138,0.1);
      min-height: 600px;
    }
    
    .smartart-wrapper {
      width: 100%;
      max-width: 1200px;
      position: relative;
      aspect-ratio: 1;
      margin: 0 auto;
    }
    
    .root-node {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: linear-gradient(135deg, #1c3e8a 0%, #2c5aa0 100%);
      color: white;
      padding: 1.5rem 2.5rem;
      border-radius: 16px;
      font-weight: bold;
      font-size: 20px;
      text-align: center;
      box-shadow: 0 6px 20px rgba(28,62,138,0.4);
      z-index: 10;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.75rem;
      white-space: nowrap;
      min-width: 220px;
    }

    .root-icon {
      width: 28px;
      height: 28px;
      stroke: white;
      flex-shrink: 0;
    }
    
    .modules-circle {
      position: relative;
      width: 100%;
      height: 100%;
    }
    
    .module-node {
      position: absolute;
      top: 50%;
      left: 50%;
      --radius: 280px;
      --angle: 0deg;
      transform: translate(-50%, -50%) 
                 rotate(var(--angle)) 
                 translateY(calc(-1 * var(--radius))) 
                 rotate(calc(-1 * var(--angle)));
    }

    .connection-line {
      position: absolute;
      top: 0;
      left: 50%;
      width: 2px;
      height: var(--radius);
      background: linear-gradient(to bottom, rgba(28,62,138,0.4), rgba(28,62,138,0.15));
      transform-origin: top center;
      transform: translateX(-50%);
      z-index: 1;
      opacity: 0.35;
      pointer-events: none;
    }

    .module-card {
      background: #ffffff;
      border: 2px solid #e0e7ff;
      border-radius: 12px;
      padding: 1.25rem 1rem;
      text-align: center;
      transition: all 0.3s ease;
      box-shadow: 0 4px 12px rgba(0,0,0,0.1);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 0.75rem;
      min-width: 160px;
      max-width: 180px;
      position: relative;
      z-index: 2;
    }

    .module-card:hover {
      transform: scale(1.05);
      box-shadow: 0 8px 24px rgba(28,62,138,0.3);
      border-color: #1c3e8a;
    }

    .module-icon {
      width: 56px;
      height: 56px;
      background: linear-gradient(135deg, #1c3e8a 0%, #2c5aa0 100%);
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 4px 10px rgba(28,62,138,0.25);
      flex-shrink: 0;
    }

    .module-icon-svg {
      width: 28px;
      height: 28px;
      stroke: white;
      stroke-width: 2;
    }

    .module-name {
      font-weight: 600;
      font-size: 13px;
      color: #1c3e8a;
      line-height: 1.3;
      word-wrap: break-word;
      hyphens: auto;
    }
    
    @media (max-width: 992px) {
      .module-node {
        --radius: 240px;
      }

      .root-node {
        padding: 1.25rem 2rem;
        font-size: 18px;
        min-width: 200px;
      }

      .module-card {
        min-width: 140px;
        max-width: 160px;
        padding: 1rem 0.75rem;
      }

      .module-icon {
        width: 50px;
        height: 50px;
      }

      .module-icon-svg {
        width: 26px;
        height: 26px;
      }

      .module-name {
        font-size: 12px;
      }
    }

    @media (max-width: 768px) {
      .module-node {
        --radius: 200px;
      }

      .smartart-container {
        padding: 2rem 1rem;
        min-height: 500px;
      }

      .root-node {
        padding: 1rem 1.5rem;
        font-size: 16px;
        min-width: 180px;
      }

      .module-card {
        min-width: 120px;
        max-width: 140px;
        padding: 0.875rem 0.5rem;
        gap: 0.5rem;
      }

      .module-icon {
        width: 44px;
        height: 44px;
      }

      .module-icon-svg {
        width: 22px;
        height: 22px;
      }

      .module-name {
        font-size: 11px;
      }

      .connection-line {
        opacity: 0.2;
      }
    }

    @media (max-width: 576px) {
      .module-node {
        --radius: 160px;
      }

      .smartart-container {
        padding: 1.5rem 0.5rem;
        min-height: 400px;
      }

      .root-node {
        padding: 0.875rem 1.25rem;
        font-size: 14px;
        min-width: 150px;
      }

      .module-card {
        min-width: 100px;
        max-width: 120px;
        padding: 0.75rem 0.5rem;
      }

      .module-icon {
        width: 40px;
        height: 40px;
      }

      .module-icon-svg {
        width: 20px;
        height: 20px;
      }

      .module-name {
        font-size: 10px;
      }
    }
  `]
})
export class ErpModulesSmartartComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() modules: Array<{ name: string; icon: string }> = [];

  ngOnInit() {
    // Component initialization
  }

  ngAfterViewInit() {
    // Initialize Lucide icons after view init
    setTimeout(() => {
      if (typeof (window as any).lucide !== 'undefined') {
        (window as any).lucide.createIcons();
      }
    }, 200);
  }

  ngOnChanges(changes: SimpleChanges) {
    // Reinitialize icons when modules change
    if (changes['modules'] && !changes['modules'].firstChange) {
      setTimeout(() => {
        if (typeof (window as any).lucide !== 'undefined') {
          (window as any).lucide.createIcons();
        }
      }, 100);
    }
  }
}

